import { render, staticRenderFns } from "./ed-section.vue?vue&type=template&id=2170ddf2&scoped=true&"
import script from "./ed-section.ts?vue&type=script&lang=ts&"
export * from "./ed-section.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section.scss?vue&type=style&index=0&id=2170ddf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2170ddf2",
  null
  
)

export default component.exports